module.exports = __webpack_public_path__ + "static/media/ic_background_login.a001f9d9.svg";